import { render, staticRenderFns } from "./OsSetPasswordForm.vue?vue&type=template&id=08def98c&scoped=true"
import script from "./OsSetPasswordForm.vue?vue&type=script&lang=ts"
export * from "./OsSetPasswordForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08def98c",
  null
  
)

export default component.exports